import { inject } from 'mobx-react';
import * as React from 'react';
import { Segment } from '../../models/segment';
import { Voucher } from '../../models/voucher';
import { InjectTranslate } from '../app/app';
import { DateView } from '../widgets/date-view';
import { DurationView } from '../widgets/duration-view';

interface CompensationDetailsProps {
  readonly segment: Segment;
  readonly voucher: Voucher;
}

export class CompensationDetailsC extends React.Component<CompensationDetailsProps & InjectTranslate> {
  public render() {
    const { segment, voucher, t } = this.props;
    const emails = voucher.emails;

    return (
      <div className="compensation-details">
        <h3>{t('send.details.header')}</h3>
        <p className="small-text">
          {t('send.details.delay_time')} <DurationView minutes={segment.delayMinutes.asMinutes()}/>
        </p>
        <p className="small-text">{t('send.details.compensation')} {voucher.amount.toString()}</p>
        <p className="small-text">{t('send.details.voucher')} {voucher.reference}</p>
        <p className="small-text">
          {t('send.details.redeemed_on')} <DateView date={voucher.created_at} format="dddd, MMM D, YYYY"/>
          <img className="checkmark" src="/assets/images/checkmark.svg"/>
        </p>
        {emails.length > 0 && <p className="small-text">
          {t('send.details.sent_to')}
          {emails[emails.length - 1].toAddress}
        </p>}
      </div>
    );
  }
}

export const CompensationDetails: React.ComponentClass<CompensationDetailsProps> = inject('t')(CompensationDetailsC);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/redeem/compensation-details.tsx